import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import db from '../../db/db';

const PrivateRoute = ({ children }) => {
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        db.sesion.count().then(count => {
            setStatus(count > 0 ? 'auth' : 'noauth');
        });
    }, []);

    if (status === 'loading') return null;
    return status === 'auth' ? children : <Navigate to="/" />;
};

export default PrivateRoute;
